import { HttpStatusCode } from 'axios';
import { ApplicationError } from './application-error.exception';

type ErrorResponse = {
  message: string;
  code?: number;
  details?: Record<string, unknown>;
  status?: HttpStatusCode;
};

type Constructor = {
  cause?: unknown;
  message: string;
  status: HttpStatusCode;
  details?: ErrorResponse;
};

class HttpError extends ApplicationError {
  public status: HttpStatusCode;
  public details?: ErrorResponse;

  public constructor({ cause, message, status, details }: Constructor) {
    super({
      cause,
      message,
    });

    this.status = status;
    this.details = details;
  }
}

export { HttpError, type ErrorResponse };
